import { App } from "./App";

//tslint:disable-next-line:no-floating-promises
(new App()).init(document.getElementById("react-root") as HTMLElement);
